import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './laudoImportacaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file';
import * as XLSX from 'xlsx';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';

import { 
	setModoTela, setAguardando, initForm, salvarImportacao, salvar, excluir, getLista, getListaGrupoFaturamentoRadiologista, getListaContratoItem, adicionarExameIgorado
} from './laudoImportacaoActions';
import { alterarColunas, getLista as getListaHospital } from '../hospital/hospitalActions';
import { getLista as getListaGrupoFaturamento } from '../grupoFaturamento/grupoFaturamentoActions';
import { salvar as salvarGrupoFaturamentoRadiologista } from '../grupoFaturamentoRadiologista/grupoFaturamentoRadiologistaActions';
import { getLista as getListaRadiologista, salvar as salvarRadiologista } from '../radiologista/radiologistaActions';
import { getLista as getListaHospitalConvenio, salvar as salvarHospitalConvenio } from '../hospitalConvenio/hospitalConvenioActions';
import { salvar as salvarContratoItem } from '../contratoItem/contratoItemActions';

import ContentCardFooter from '../common/template/contentCardFooter';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInput from '../common/form/labelAndInput';

class LaudoImportacaoProcesso extends Component {

	state = {
		paginacaoIndice: 0,
		processamento: {
		}
	}

	componentDidMount() {
		this.props.getListaHospital();
		this.props.getListaRadiologista();
		this.props.getListaGrupoFaturamento();
		this.props.getListaHospitalConvenio();
		this.props.getListaGrupoFaturamentoRadiologista();
		this.props.getListaContratoItem();
	}

    render() {
		return (
			<>	
				<Aguardando aguardando={this.props.Aguardando} />
				
				{!this.state.processamento.arquivo ? (
					this.selecaoArquivo()
				) : (!this.state.processamento.headerProcessado ? (
					this.processamentoHeader()
				) : (
					this.processamentoLinhas()
				))}
			</>
		);
	}

	selecaoArquivo() {
		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<Select
							options={this.props.listaHospital}
							label='Hospital *'
							cols='12 12 12 12'
							placeholder='Selecione'
							value={this.state.processamento.id_hospital}
							onChange={value => {
								this.setState({
									processamento: {
										...this.state.processamento,
										id_hospital: value
									}
								});
							}} />
					</Row>

					{this.state.processamento.id_hospital != null &&
					<Row>
						<Grid cols='12 12 12 12'>
							<ClipboardImageHandler
								id='arquivo-xlsx'
								label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
								msgErro='Selecione apenas (.xls e .xlsx)'
								types={[
									'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
									'application/vnd.ms-excel'
								]}
								onChange={async (base64, file) => {
									if (file) {

										const dadosXlsx = await this.extrairTabelaExcel(
											file, 
											file.type.includes('application/vnd.ms-excel') ? 'xls' : 'xlsx'
										);
										
										const hospital = this.props.listaHospital.filter(item => item.id == this.state.processamento.id_hospital)[0];

										this.setState({
											processamento: {
												...this.state.processamento,
												arquivo: file,
												arquivoBase64: base64,
												arquivoTipo: file.type.includes('application/vnd.ms-excel') ? 'xls' : 'xlsx',
												dadosXlsx: dadosXlsx,
												hospital: {
													...hospital
												}
											}
										});
									}
								}} />
						</Grid>
					</Row>}
				</ContentCardBody>
				<ContentCardFooter>
					<Row alignCenter>
						<Grid cols='12 6 4 3'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('lista');
								}} />
						</Grid>
					</Row>
				</ContentCardFooter>
			</ContentCard>
		);
	}

	async extrairTabelaExcel(file, tipo) {
		
		if (tipo == 'xlsx') {
			let tabela = [];
			await readXlsxFile(file, { sheet: 1 }).then((rows) => {
				tabela = rows;
			});
			return {
				cabecalho: tabela[0].map((item, i) => (item || '').trim()),
				lista: tabela.filter((item, i) => i > 0).map((item, i) => ({ ...item, idAux: i }))
			};
		} else {
			const { cabecalho, lista } = await this.lerArquivoXLS(file);

			return {
				cabecalho: cabecalho.map((item, i) => (item || '').trim()),
				lista: lista.filter((item, i) => i > 0).map((item, i) => ({ ...item, idAux: i }))
			}; 
		}
	}

	lerArquivoXLS(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = (event) => {
				try {
					const data = new Uint8Array(event.target.result);
					const workbook = XLSX.read(data, { type: 'array' });

					const sheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[sheetName];
					const jsonData = XLSX.utils.sheet_to_json(worksheet);

					let cabecalho = [];
					let lista = [];
					if (jsonData[0]) {
						cabecalho = Object.keys(jsonData[0]);
						lista = jsonData.map(obj => {
							return cabecalho.map(coluna => obj[coluna]);
						});
					}

					resolve({ cabecalho, lista });
				} catch (err) {
					reject(err);
				}
			};

			reader.onerror = reject;
			reader.readAsArrayBuffer(file);
		});
	};

	processamentoHeader() {
		
		const dadosXlsx = this.state.processamento.dadosXlsx;
		const hospital = this.state.processamento.hospital;
		
		return (
			<ContentCard>
				<ContentCardBody>
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: this.state.competencia ? null : '#ff0000' }}>
								Competência: <i class={this.state.competencia ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={Array.from(Array(24).keys()).map(item => {
								
								let data = new Date();
								data.setMonth(data.getMonth() - 4 + item);

								return {
									id: parseInt(`${data.getFullYear()}${String(data.getMonth() + 1).padStart(2, '0')}`),
									valor: `${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`
								};
							})}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={this.state.competencia}
							onChange={data => this.setState({ ...this.state, competencia: data.target.value })} />
					</Row>
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_convenio) ? null : '#ff0000' }}>
								Convênio: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_convenio) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_convenio}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_convenio: data.target.value })} />
					</Row>
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_sigla_exame) ? null : '#ff0000' }}>
								Sigla do Exame: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_sigla_exame) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_sigla_exame}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_sigla_exame: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_observacao_exame) ? null : '#ff0000' }}>
								Observação do Exame: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_observacao_exame) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_observacao_exame}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_observacao_exame: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_radiologista) ? null : '#ff0000' }}>
								Radiologista: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_radiologista) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_radiologista}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_radiologista: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_nome_paciente) ? null : '#ff0000' }}>
								Nome do Paciente: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_nome_paciente) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_nome_paciente}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_nome_paciente: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_data_exame) ? null : '#ff0000' }}>
								Data do Exame: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_data_exame) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_data_exame}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_data_exame: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_quantidade) ? null : '#ff0000' }}>
								Quantidade: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_quantidade) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_quantidade}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_quantidade: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_laudo) ? null : '#ff0000' }}>
								Laudo: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_laudo) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_laudo}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_laudo: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_medico_solicitante) ? null : '#ff0000' }}>
								Médico Solicitante: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_medico_solicitante) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_medico_solicitante}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_medico_solicitante: data.target.value })} />
					</Row>
					
					<Row alignCenter>
						<Grid cols='6 6 6 6' style={{ maxWidth: 185, marginTop: 8 }}>
							<label style={{ color: dadosXlsx.cabecalho.includes(hospital.importacao_digitador) ? null : '#ff0000' }}>
								Digitador: <i class={dadosXlsx.cabecalho.includes(hospital.importacao_digitador) ? 'fas fa-check-double' : 'fas fa-exclamation-triangle'} />
							</label>
						</Grid>
						<SelectDefault
							options={dadosXlsx.cabecalho.map(item => ({ id: item, valor: item }))}
							cols='6 6 6 4'
							placeholder='Selecione'
							value={hospital.importacao_digitador}
							onChange={data => this.atualizarColunaHospital({ ...hospital,  importacao_digitador: data.target.value })} />
					</Row>
				</ContentCardBody>
				<ContentCardFooter>
					<Row alignCenter>
						<Grid cols='12 6 4 3'>
							<Button
								text='Processar Planilha'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									if (this.state.competencia) {
										this.props.alterarColunas({
											...hospital
										});
								
										this.processarItens();
									} else {
										window.alert('Informe a Competência');
									}
								}} />
						</Grid>
						<Grid cols='12 6 4 3'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('lista');
								}} />
						</Grid>
					</Row>
				</ContentCardFooter>
			</ContentCard>
		);
	}

	atualizarColunaHospital(registro) {
		this.setState({
			processamento: {
				...this.state.processamento,
				hospital: {
					...registro
				}
			}
		});
	}

	processarItens() {
		
		const dadosXlsx = this.state.processamento.dadosXlsx;
		const hospital = this.state.processamento.hospital;
 
		const posicaoConvenio = hospital.importacao_convenio ? dadosXlsx.cabecalho.indexOf(hospital.importacao_convenio) : -1;
		const posicaoSiglaExame = hospital.importacao_sigla_exame ? dadosXlsx.cabecalho.indexOf(hospital.importacao_sigla_exame) : -1;
		const posicaoObservacaoExame = hospital.importacao_observacao_exame ? dadosXlsx.cabecalho.indexOf(hospital.importacao_observacao_exame) : -1;
		const posicaoRadiologista = hospital.importacao_radiologista ? dadosXlsx.cabecalho.indexOf(hospital.importacao_radiologista) : -1;
		const posicaoNomePaciente = hospital.importacao_nome_paciente ? dadosXlsx.cabecalho.indexOf(hospital.importacao_nome_paciente) : -1;
		const posicaoDataExame = hospital.importacao_data_exame ? dadosXlsx.cabecalho.indexOf(hospital.importacao_data_exame) : -1;
		const posicaoQuantidade = hospital.importacao_quantidade ? dadosXlsx.cabecalho.indexOf(hospital.importacao_quantidade) : -1;
		const posicaoLaudo = hospital.importacao_laudo ? dadosXlsx.cabecalho.indexOf(hospital.importacao_laudo) : -1;
		const posicaoMedicoSolicitante = hospital.importacao_medico_solicitante ? dadosXlsx.cabecalho.indexOf(hospital.importacao_medico_solicitante) : -1;
		const posicaoDigitador = hospital.importacao_digitador ? dadosXlsx.cabecalho.indexOf(hospital.importacao_digitador) : -1;

		let listaProcessada = [];
		for (let index = 0; index < dadosXlsx.lista.length; index++) {
			const item = dadosXlsx.lista[index];
			
			let hospitalConvenio = this.props.listaHospitalConvenio.filter(itemHospitalConvenio => 
				itemHospitalConvenio.id_hospital == hospital.id 
				&& (
					itemHospitalConvenio.valor.trim().toUpperCase() == (item[posicaoConvenio] || '').trim().toUpperCase()
					|| itemHospitalConvenio.outros.toUpperCase().split(';')
						.filter(outro => outro.trim()).filter(outro => outro.trim() == (item[posicaoConvenio] || '').trim().toUpperCase()).length > 0
				)
			)[0];
			if (!hospitalConvenio) {
				hospitalConvenio = this.props.listaHospitalConvenio.filter(itemHospitalConvenio => itemHospitalConvenio.id_hospital == hospital.id).length == 1
					? this.props.listaHospitalConvenio.filter(itemHospitalConvenio => itemHospitalConvenio.id_hospital == hospital.id)[0]
					: this.props.listaHospitalConvenio.filter(itemHospitalConvenio => 
						itemHospitalConvenio.id_hospital == hospital.id 
						&& itemHospitalConvenio.valor.trim().toUpperCase() == 'PADRÃO'
					)[0]
			}
			const radiologista = this.props.listaRadiologista.filter(itemRadiologista => 
				itemRadiologista.valor.trim().toUpperCase() == (item[posicaoRadiologista] || '').trim().toUpperCase()
			)[0];

			const grupoFaturamento = radiologista 
				? this.props.listaGrupoFaturamentoRadiologista.filter(itemGrupoFaturamento => itemGrupoFaturamento.id_radiologista == radiologista.id)[0] 
				: null;

			const contrato = grupoFaturamento 
				? this.props.listaContratoItem.filter(itemContrato => itemContrato.id_hospital == hospital.id && itemContrato.ids_grupo_faturamento.includes(grupoFaturamento.id_grupo_faturamento))[0]
				: null;

			//Busca primeiro o que tem Sigla e Observação
			let exame = contrato && hospitalConvenio && item[posicaoSiglaExame]
				? this.props.listaContratoItem.filter(itemContrato => 
					itemContrato.id_contrato == contrato.id_contrato 
					&& itemContrato.id_hospital_convenio == hospitalConvenio.id
				).filter(itemContrato => {

					//Busca a sigla
					const exame1 = (itemContrato.sigla_exame1 || '').split(';').length > 0 && (itemContrato.sigla_exame1 || '').split(';').map(sigla => sigla.trim()).filter(sigla => sigla).filter(sigla => item[posicaoSiglaExame].includes(sigla)).length > 0;
					
					if (exame1 && item[posicaoObservacaoExame]) {
						const observacaoExame1 = (itemContrato.observacao_exame1 || '').split(';').length > 0 && (itemContrato.observacao_exame1 || '').split(';').map(observacao => observacao.trim()).filter(observacao => observacao).filter(observacao => item[posicaoObservacaoExame].includes(observacao)).length > 0;

						//Se achou a observação
						if (observacaoExame1) {
							return true;
						}
					}

					//Busca a sigla
					const exame2 = (itemContrato.sigla_exame2 || '').split(';').length > 0 && (itemContrato.sigla_exame2 || '').split(';').map(sigla => sigla.trim()).filter(sigla => sigla).filter(sigla => item[posicaoSiglaExame].includes(sigla)).length > 0;
					
					if (exame2 && item[posicaoObservacaoExame]) {
						const observacaoExame2 = (itemContrato.observacao_exame2 || '').split(';').length > 0 && (itemContrato.observacao_exame2 || '').split(';').map(observacao => observacao.trim()).filter(observacao => observacao).filter(observacao => item[posicaoObservacaoExame].includes(observacao)).length > 0;
						//Se achou a observação
						if (observacaoExame2) {
							return true;
						}
					}

					return false;

				})[0] : null;

			if (!exame) {
				//Busca apenas pela sigla e se não existe observação
				exame = contrato && hospitalConvenio && item[posicaoSiglaExame]
					? this.props.listaContratoItem.filter(itemContrato => 
						itemContrato.id_contrato == contrato.id_contrato 
						&& itemContrato.id_hospital_convenio == hospitalConvenio.id
					).filter(itemContrato => {

						//Busca a sigla
						const exame1 = (itemContrato.sigla_exame1 || '').split(';').length > 0 && (itemContrato.sigla_exame1 || '').split(';').map(sigla => sigla.trim()).filter(sigla => sigla).filter(sigla => item[posicaoSiglaExame].includes(sigla)).length > 0;
						//Se achou a sigla e não existe observação
						if (exame1 && !itemContrato.observacao_exame1) {
							return true;
						}

						//Busca a sigla
						const exame2 = (itemContrato.sigla_exame2 || '').split(';').length > 0 && (itemContrato.sigla_exame2 || '').split(';').map(sigla => sigla.trim()).filter(sigla => sigla).filter(sigla => item[posicaoSiglaExame].includes(sigla)).length > 0;
						// Se achou a sigla e não existe observação
						if (exame2 && !itemContrato.observacao_exame2) {
							return true;
						}

						return false;

					})[0] : null;
			}

			const dataExame = DateFormat.formatarDataHoraTelaParaSql(item[posicaoDataExame]);
			let plantao = false;
			if (dataExame && contrato && (contrato.feriados || []).map(feriado => feriado.split('-').join('/')).includes(dataExame.split(' ')[0].split('-').join('/'))) {
				plantao = true;
			} else if (contrato && contrato.horario_plantao_inicio && contrato.horario_plantao_fim) {				
				const hora = `${dataExame.split(' ')[1].split(':')[0]}:${dataExame.split(' ')[1].split(':')[1]}`
				if (contrato.horario_plantao_inicio < contrato.horario_plantao_fim) {
					//O período inicia e finaliza no mesmo dia
					plantao = hora >= contrato.horario_plantao_inicio && hora <= contrato.horario_plantao_fim;
				} else {
					//O período inicia em um dia e termina em outro
					plantao = hora >= contrato.horario_plantao_inicio || hora <= contrato.horario_plantao_fim;
				}
			}

			const registro = {
				idAux: index + 1,
				competencia: this.state.competencia,
				id_hospital: hospital.id,
				id_hospital_convenio: hospitalConvenio ? hospitalConvenio.id : null,
				nome_hospital_convenio: hospitalConvenio ? hospitalConvenio.valor : item[posicaoConvenio],
				id_exame: exame ? exame.id_exame : null,
				nome_exame: exame ? exame.nome_exame : `${item[posicaoSiglaExame]} - ${item[posicaoObservacaoExame]}`,
				sigla_exame: item[posicaoSiglaExame],
				descricao_exame: item[posicaoObservacaoExame],
				id_radiologista: radiologista ? radiologista.id : null,
				nome_radiologista: radiologista ? radiologista.valor : item[posicaoRadiologista],
				id_grupo_faturamento: grupoFaturamento ? grupoFaturamento.id_grupo_faturamento : null,
				nome_grupo_faturamento: grupoFaturamento ? grupoFaturamento.nome_grupo_faturamento : null,
				id_contrato: contrato ? contrato.id_contrato : null,
				nome_contrato: contrato ? DateFormat.formatarDataSqlParaTela(contrato.data_inicio) : null,
				nome_paciente: contrato && contrato.salvar_paciente ? item[posicaoNomePaciente] : null,
				datahora_exame: DateFormat.formatarDataHoraTelaParaSql(item[posicaoDataExame]),
				plantao: plantao,
				quantidade: item[posicaoQuantidade] || 1,
				laudo: item[posicaoLaudo],
				medico_solicitante: item[posicaoMedicoSolicitante],
				digitador: item[posicaoDigitador],
				valor: exame ? (plantao ? (exame.valor_plantao || exame.valor) : exame.valor) : 0,
				percentual_imposto: contrato ? (contrato.percentual_imposto || 0) : 0
			};

			if (!registro.nome_radiologista) {
				//Não adiciona na lista, pois será ignorado
			} else if (grupoFaturamento && grupoFaturamento.nome_grupo_faturamento == 'Grupo Ignorado') {
				//Não adiciona na lista, pois será ignorado
			} else if (!exame && contrato && contrato.exames_ignorar 
					&& (
						contrato.exames_ignorar.split(',').map(item => item.trim()).includes(registro.sigla_exame) 
						|| contrato.exames_ignorar.split(',').map(item => item.trim().replace(/\\\\/g, '\\')).includes(registro.sigla_exame)
					)) {
				//Não adiciona na lista, pois será ignorado
			} else {
				listaProcessada.push(registro);
			}
		}

		this.atualizarListaProcessada(listaProcessada);
		
	}

	atualizarListaProcessada(lista) {
		this.setState({
			processamento: {
				...this.state.processamento,
				headerProcessado: true,
				dadosXlsx: {
					...this.state.processamento.dadosXlsx,
					listaProcessada: lista
				}
			},
			modalExame: null
		});
	}

	processamentoLinhas() {
		
		const dadosXlsx = this.state.processamento.dadosXlsx;
		const hospital = this.state.processamento.hospital;
		
		let paginacao = [];

		if (dadosXlsx.listaProcessada.length) {
			for (let i = 0; i < dadosXlsx.listaProcessada.length; i += 500) {				
				paginacao.push({
					inicio: i,
					fim: i + 499
				});				
			}
		} else {
			paginacao.push({
				inicio: 0,
				fim: 499
			});
		}

		return (
			<ContentCard>
			
				{this.modalExame()}

				<ContentCardBody>
					<div 
						style={{ 
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (window.innerHeight - 150)
						}}>

						<ul class='pagination pagination-sm m-0 float-right'>
							<li class='page-item'>
								<a class='page-link' 
									style={{ 
										cursor: 'pointer'
									}}
									onClick={() => this.setState({
										...this.state,
										paginacaoIndice: this.state.paginacaoIndice > 0 ? this.state.paginacaoIndice - 1 : this.state.paginacaoIndice
									})}>{'<<'}
								</a>
							</li>
							
							{paginacao.map((item, i) => (
								<li class='page-item'>
									<a class='page-link'  
										style={{ 
											fontWeight: 'bold',
											cursor: 'pointer',
											backgroundColor: i == this.state.paginacaoIndice ? '#007bff' : null,
											color: i == this.state.paginacaoIndice ? '#fff' : null
										}}
										onClick={() => this.setState({
											...this.state,
											paginacaoIndice: i
										})}>{i + 1}
									</a>
								</li>
							))}
							
							<li class='page-item'>
								<a class='page-link' 
									style={{ 
										cursor: 'pointer'
									}}
									onClick={() => this.setState({
										...this.state,
										paginacaoIndice: paginacao.length - 1 > this.state.paginacaoIndice ? this.state.paginacaoIndice + 1 : this.state.paginacaoIndice
									})}>{'>>'}
								</a>
							</li>
						</ul>

						<Table responsive border striped alturaFixa 
								maxHeight={window.innerWidth < 768 ? '100%' : (window.innerHeight - 200)}>
							<THead backgroundColor={'#ffffff'}>
								<Tr>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}></Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Radiologista</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Grp. Faturamento</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Contrato</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Convênio</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Exame</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Qtd.</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Valor</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Imposto</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Nome do Paciente</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Data do Exame</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Laudo</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Médico Solicitante</Th>
									<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Digitador</Th>
								</Tr>
							</THead>
							<TBody>
								{dadosXlsx.listaProcessada.filter((item, i) => {
									return i >= paginacao[this.state.paginacaoIndice].inicio && i <= paginacao[this.state.paginacaoIndice].fim;
								}).map(item => (
									<Tr key={item.idAux} >
										<Td alignCenter title='Status'>
											{(!item.id_radiologista
												|| !item.id_grupo_faturamento
												|| !item.id_contrato
												|| !item.id_hospital_convenio
												|| !item.id_exame
											) ? (
												<i class='fas fa-ban' style={{ color: '#ff0000' }} title='Não será importado'></i>
											) : (
												<i class='fas fa-check-double' style={{ color: '#006b04' }} title='Será importado'></i>
											)}
										</Td>
										<Td alignCenter small title='Radiologista'
											backgroundColor={item.id_radiologista ? null : '#ff0000'}
											color={item.id_radiologista ? null : '#ffffff'}>
											{item.nome_radiologista}
											{(!item.id_radiologista && item.nome_radiologista) &&
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												event={() => {
													this.cadastrarRadiologista({
														...item
													});
												}} />}
										</Td>
										<Td alignCenter small title='Grupo de Faturamento'
											backgroundColor={item.id_grupo_faturamento ? null : '#ff0000'}
											color={item.id_grupo_faturamento ? null : '#ffffff'}>
											{!item.adicionarGrupoFaturamento ? (
												<>
													{item.nome_grupo_faturamento}
													{(!item.id_grupo_faturamento && item.id_radiologista) &&
													<ButtonTable
														type={'warning'}
														icon={'fas fa-pencil-alt'}
														visible={true}
														title='Selecionar Grupo de Faturamento'
														event={() => {
															this.atualizarListaProcessada(dadosXlsx.listaProcessada.map(itemAux => ({
																...itemAux,
																adicionarGrupoFaturamento: itemAux.idAux == item.idAux
															})));
														}} />}
												</>
											) : (
												<SelectDefault
													minWidth={100} 
													options={this.props.listaGrupoFaturamento}
													cols='12 12 12 12'
													placeholder='Selecione'
													onChange={data => {
														if (data.target.value) {
															this.cadastrarGrupoFaturamento({
																id_radiologista: item.id_radiologista,
																id_grupo_faturamento: data.target.value
															});
														}
													}} />
											)}
										</Td>
										<Td alignCenter small title=''
											backgroundColor={item.id_contrato ? null : '#ff0000'}
											color={item.id_contrato ? null : '#ffffff'}>{item.nome_contrato}</Td>
										
										<Td alignCenter small
											backgroundColor={item.id_hospital_convenio ? null : '#ff0000'}
											color={item.id_hospital_convenio ? null : '#ffffff'}>
											{!item.adicionarConvenio ? (
												<>
													{item.nome_hospital_convenio}
													{(!item.id_hospital_convenio && item.nome_hospital_convenio) &&
													<ButtonTable
														type={'warning'}
														icon={'fas fa-pencil-alt'}
														visible={true}
														title='Selecionar Convênio'
														event={() => {
															this.atualizarListaProcessada(dadosXlsx.listaProcessada.map(itemAux => ({
																...itemAux,
																adicionarConvenio: itemAux.idAux == item.idAux
															})));
														}} />}
												</>
											) : (
												<SelectDefault
													minWidth={100} 
													options={this.props.listaHospitalConvenio.filter(itemHospitalConvenio => (
														itemHospitalConvenio.id_hospital == item.id_hospital
													))}
													cols='12 12 12 12'
													placeholder='Selecione'
													onChange={data => {
														if (data.target.value) {
															this.cadastrarHospitalConvenio({
																id: data.target.value,
																nome_hospital_convenio: item.nome_hospital_convenio
															});
														}
													}} />
											)}
										</Td>
										<Td alignCenter small
											backgroundColor={item.id_exame ? null : '#ff0000'}
											color={item.id_exame ? null : '#ffffff'}
											title={`${item.sigla_exame} - ${item.descricao_exame}`}>
											{!item.adicionarExame ? (
												<>
													{item.nome_exame}
													{(!item.id_exame && item.nome_exame && item.id_hospital_convenio && item.id_contrato) &&
													<ButtonTable
														type={'warning'}
														icon={'fas fa-pencil-alt'}
														visible={true}
														title='Selecionar Exame'
														event={() => {
															this.atualizarListaProcessada(dadosXlsx.listaProcessada.map(itemAux => ({
																...itemAux,
																adicionarExame: itemAux.idAux == item.idAux
															})));
														}} />}

													{(!item.id_exame && item.nome_exame && item.id_hospital_convenio && item.id_contrato) &&
													<ButtonTable
														type={'danger'}
														icon={'fas fa-trash'}
														visible={true}
														title='Ignorar Exame'
														event={() => {
															this.adicionarExameIgorado({
																id: item.id_contrato,
																nome_exame_ignorar: item.sigla_exame
															});															
														}} />}
												</>
											) : (
												<SelectDefault
													minWidth={100} 
													options={this.props.listaContratoItem.filter(itemContrato => 
														itemContrato.id_contrato == item.id_contrato 
														&& itemContrato.id_hospital_convenio == item.id_hospital_convenio
													).map(itemContrato => ({ id: itemContrato.id, valor: itemContrato.nome_exame }))}
													cols='12 12 12 12'
													placeholder='Selecione'
													onChange={data => {
														if (data.target.value) {
															const itemContrato = this.props.listaContratoItem.filter(itemContrato => itemContrato.id == data.target.value)[0];
															if (itemContrato) {
																this.setState({
																	modalExame: {
																		itemContrato: itemContrato,
																		nome_exame: item.nome_exame,
																		sigla_exame: item.sigla_exame,
																		descricao_exame: item.descricao_exame
																	}
																});
															}
														}
													}} />
											)}
										</Td>
										<Td alignCenter small>{item.quantidade}</Td>
										<Td alignCenter small>R$ {FormatUtils.formatarValorTela(item.valor, 2)}</Td>
										<Td alignCenter small>{FormatUtils.formatarValorTela(item.percentual_imposto, 2)} %</Td>
										<Td alignCenter small>{item.nome_paciente}</Td>
										<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_exame)}</Td>
										<Td alignCenter small>{item.laudo}</Td>
										<Td alignCenter small>{item.medico_solicitante}</Td>
										<Td alignCenter small>{item.digitador}</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
				<ContentCardFooter>
					<Row alignCenter>
						<Grid cols='12 6 4 3'>
							<Button
								text='Finalizar Importação'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									if (window.confirm('Apenas serão importadas as linha que não possuam nenhuma coluna em vermelho. Deseja continuar?')) {
										this.props.salvarImportacao(
											dadosXlsx.listaProcessada.filter(item => 
												item.id_radiologista
												&& item.id_grupo_faturamento
												&& item.id_contrato
												&& item.id_hospital_convenio
												&& item.id_exame
											)
										);
									}
								}} />
						</Grid>
						<Grid cols='12 6 4 3'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('lista');
								}} />
						</Grid>
					</Row>
				</ContentCardFooter>
			</ContentCard>
		);
	}

	cadastrarGrupoFaturamento(registro) {
		if (window.confirm('Deseja realmente adicionar esse radiologista ao grupo de faturamento?')) {
			this.props.setAguardando(true);

			setTimeout(() => {
				this.props.salvarGrupoFaturamentoRadiologista({
					id_radiologista: registro.id_radiologista,
					id_grupo_faturamento: registro.id_grupo_faturamento
				}, () => {
					this.props.getListaGrupoFaturamentoRadiologista(() => {
						setTimeout(() => {
							this.processarItens();
							this.props.setAguardando(false);
						}, 500);
					});					
				});
			}, 500);
		}
	}

	cadastrarRadiologista(registro) {
		if (window.confirm('Deseja realmente adicionar esse radiologista?')) {
			this.props.setAguardando(true);

			setTimeout(() => {
				this.props.salvarRadiologista({
					nome: registro.nome_radiologista,
					cpf: '00000000000',
					crm: '0000000'
				}, () => {
					setTimeout(() => {
						this.processarItens();
						this.props.setAguardando(false);
					}, 500);
				});
			}, 500);
		}
	}

	adicionarExameIgorado(registro) {
		if (window.confirm('Deseja realmente ignorar esse exame?')) {
			this.props.setAguardando(true);

			setTimeout(() => {

				this.props.adicionarExameIgorado({
					...registro
				}, () => {
					setTimeout(() => {
						this.processarItens();
						this.props.setAguardando(false);
					}, 500);
				});
			}, 500);
		}
	}

	cadastrarHospitalConvenio(registro) {
		if (window.confirm('Deseja realmente adicionar esse convênio?')) {
			this.props.setAguardando(true);

			setTimeout(() => {

				let hospitalConvenio = this.props.listaCompletaHospitalConvenio.filter(itemHospitalConvenio => itemHospitalConvenio.id == registro.id)[0];
	
				this.props.salvarHospitalConvenio({
					...hospitalConvenio,
					outros: hospitalConvenio.outros ? `${hospitalConvenio.outros}; ${registro.nome_hospital_convenio}`
						: registro.nome_hospital_convenio 
				}, () => {
					setTimeout(() => {
						this.processarItens();
						this.props.setAguardando(false);
					}, 500);
				});
			}, 500);
		}
	}

	modalExame() {

		if (!this.state.modalExame) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Exame</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalExame: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							
							<Row>
								<Grid cols='12 12 12 12'>
									<p><b>Exame Selecionado: </b>{this.state.modalExame.itemContrato.nome_exame}</p>
									<p><b>Sigla da Importação: </b>{this.state.modalExame.sigla_exame}</p>
									<p><b>Descrição da Importação: </b>{this.state.modalExame.descricao_exame}</p>
								</Grid>
							</Row>

							<Row>
								<LabelAndInput
									name='sigla_exame1'
									label='Sigla do Exame'
									cols='12 4 3 2'
									placeholder='Selecione'
									value={this.state.modalExame.itemContrato.sigla_exame1}
									onChange={data => {
										this.setState({
											modalExame: {
												...this.state.modalExame,
												itemContrato: {
													...this.state.modalExame.itemContrato,
													sigla_exame1: data.target.value
												}
											}
										});
									}}/>
								
								<LabelAndInput
									name='observacao_exame1'
									label='Observação no Exame'
									cols='12 8 9 10'
									placeholder='Selecione'
									value={this.state.modalExame.itemContrato.observacao_exame1}
									onChange={data => {
										this.setState({
											modalExame: {
												...this.state.modalExame,
												itemContrato: {
													...this.state.modalExame.itemContrato,
													observacao_exame1: data.target.value
												}
											}
										});
									}} />
							</Row>

							<Row>
								<LabelAndInput
									name='sigla_exame2'
									label='Sigla'
									cols='12 4 3 2'
									placeholder='Selecione'
									value={this.state.modalExame.itemContrato.sigla_exame2}
									onChange={data => {
										this.setState({
											modalExame: {
												...this.state.modalExame,
												itemContrato: {
													...this.state.modalExame.itemContrato,
													sigla_exame2: data.target.value
												}
											}
										});
									}} />

								<LabelAndInput
									name='observacao_exame2'
									label='Observação no Exame'
									cols='12 8 9 10'
									placeholder='Selecione'
									value={this.state.modalExame.itemContrato.observacao_exame2}
									onChange={data => {
										this.setState({
											modalExame: {
												...this.state.modalExame,
												itemContrato: {
													...this.state.modalExame.itemContrato,
													observacao_exame2: data.target.value
												}
											}
										});
									}} />
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {

									if (window.confirm('Deseja realmente adicionar esse convênio?')) {
										this.props.setAguardando(true);
							
										setTimeout(() => {							
											this.props.salvarContratoItem({
												...this.state.modalExame.itemContrato,
												valor: FormatUtils.formatarValorTela(this.state.modalExame.itemContrato.valor, 2),
												valor_plantao: FormatUtils.formatarValorTela(this.state.modalExame.itemContrato.valor_plantao, 2),
												percentual_imposto: FormatUtils.formatarValorTela(this.state.modalExame.itemContrato.percentual_imposto, 2)
											}, () => {
												this.props.getListaContratoItem(() => {
													setTimeout(() => {
														this.processarItens();
														this.props.setAguardando(false);
													}, 500);
												});
											});
										}, 500);
									}

								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }
}


const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.laudoImportacao.modoTela,
	aguardando: state.laudoImportacao.aguardando,
	listaHospital: state.hospital.listaSelect,
	listaGrupoFaturamento: state.grupoFaturamento.listaSelect,
	listaRadiologista: state.radiologista.listaSelect,
	listaHospitalConvenio: state.hospitalConvenio.listaSelect,
	listaCompletaHospitalConvenio: state.hospitalConvenio.lista,
	listaGrupoFaturamentoRadiologista: state.laudoImportacao.listaGrupoFaturamentoRadiologista,
	listaContratoItem: state.laudoImportacao.listaContratoItem
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, setAguardando, initForm, salvarImportacao, salvar, excluir, getLista, 
	alterarColunas, getListaHospital, 
	getListaGrupoFaturamento,
	salvarGrupoFaturamentoRadiologista,
	getListaRadiologista, salvarRadiologista,
	getListaHospitalConvenio, salvarHospitalConvenio, 
	getListaGrupoFaturamentoRadiologista, getListaContratoItem,
	salvarContratoItem, adicionarExameIgorado
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoImportacaoProcesso);